<template>
  <button
    :id="id"
    :class="[
      'btn btn-icon d-flex align-items-center position-relative',
      {'icon-button-hover-focus': hoverable},
      `btn-${variant} btn-${size}`,
    ]"
    :disabled="disabled"
    type="button"
  >
    <Transition mode="out-in">
      <span v-if="loading" class="spinner-container">
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
      </span>
      <Icon v-else :icon="iconName" color="currentColor" />
    </Transition>
    <span
      v-if="badge"
      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger mt-1"
      :style="{fontSize: getBadgeFontSize(size)}"
    >
      {{ badge }}
      <span class="visually-hidden">unread notifications</span>
    </span>
  </button>
</template>
<script lang="ts" setup>
withDefaults(
  defineProps<{
    badge?: string;
    disabled?: boolean;
    hoverable?: boolean;
    iconName: string;
    id?: string;
    loading?: boolean;
    size?: string;
    variant?: string;
  }>(),
  {
    badge: '',
    disabled: false,
    hoverable: true,
    id: 'ghost',
    loading: false,
    size: 'sm',
    variant: 'ghost',
  },
);

const getBadgeFontSize = (size: string) => {
  switch (size) {
    case 'sm':
      return '0.45rem';
    case 'md':
      return '0.55rem';
    case 'lg':
      return '0.6rem';
    default:
      return '0.6rem';
  }
};
</script>
<style lang="scss" scoped>
// The Bootstrap spinner uses rem. Switch to em to match Iconify's sizing
.spinner-container {
  display: flex;
  align-items: center;
  font-size: var(--bs-btn-font-size);
  width: 1em; // Match Iconify svg
  height: 1em;
  padding: 0.1em;
}

.spinner-border-sm {
  --bs-spinner-width: 100%; // Match the Iconify svg padding above
  --bs-spinner-height: 100%;
  --bs-spinner-border-width: 0.15em;
}
</style>
